var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 99,
    viewBox: "0 0 82 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2175 66.2998C32.6025 66.9565 32.1852 67.7905 31.4822 68.0826C30.8964 68.326 30.2227 68.1731 29.9035 67.6248C29.1953 66.4085 28.5738 65.1381 27.8005 64.1714C26.0777 61.7102 24.1087 59.4951 22.3858 57.0339C19.6785 53.3421 17.4634 49.6503 16.4789 44.974C14.2638 33.4063 20.6629 22.0848 31.7384 17.6546C46.2595 11.7477 62.9957 21.5925 65.2108 37.0981C66.1953 44.2356 63.9802 50.1425 60.0423 55.8033C58.3194 58.2645 56.1044 60.7257 54.3815 63.4331C53.1509 65.1559 52.4126 66.8788 51.182 68.6016C50.6897 69.34 50.1975 70.0783 49.4591 70.3244C43.7983 72.5395 38.1376 74.5085 32.4768 76.4775C32.2131 76.5654 31.9808 76.5905 31.78 76.564C31.1106 76.476 30.765 75.6562 30.8682 74.989C30.8974 74.8002 30.9699 74.6324 31.0991 74.499C31.3138 74.2775 31.6472 74.1791 31.9277 74.051C32.5947 73.7465 33.3224 73.6465 34.0144 73.4041C38.5883 71.8021 43.1623 70.1851 47.7362 68.3555C48.2285 68.1094 48.7207 67.6171 48.9668 67.1249C50.9358 63.4331 53.397 60.4796 55.8583 57.0339C58.3195 53.8344 60.5345 50.8809 61.519 46.943C63.9802 39.0671 62.2574 32.1757 56.8427 26.2688C50.6897 19.3774 42.8139 17.1623 33.9535 19.8697C25.0932 22.577 20.1707 28.73 18.4479 37.8365C17.2173 44.2356 19.4323 49.6503 23.1241 54.5727C25.217 57.3632 27.3099 60.1536 29.4027 62.9441C29.6454 63.2677 29.9482 63.5398 30.2591 63.7985C31.0721 64.4751 31.6477 65.3281 32.2175 66.2998Z",
    fill: "url(#paint0_linear_2305_20661)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3451 91.8014C32.0099 91.7881 31.5559 91.8504 31.3122 91.6199C31.1423 91.4593 31 91.2658 31 91.0011C31 90.6538 31.1225 90.3066 31.281 89.9594C31.4131 89.6701 31.5229 89.3415 31.8379 89.2974C32.0743 89.2644 32.3452 89.2365 32.5697 89.155C37.8813 87.2271 43.419 85.2992 48.7207 83.3713C49.9513 82.8791 50.4435 83.1252 50.6897 83.8636C50.9358 84.6019 50.4435 85.3403 49.4591 85.8325C43.9568 87.7464 38.687 89.6602 33.1977 91.8001C32.9092 91.9126 32.6545 91.8136 32.3451 91.8014Z",
    fill: "url(#paint1_linear_2305_20661)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.503 83.8606C32.0552 83.8606 31.5128 83.7318 31.2163 83.3963C31.092 83.2556 31 83.0888 31 82.8761C31 82.5288 31.1225 82.1816 31.281 81.8344C31.4131 81.5451 31.5229 81.2165 31.8379 81.1724C32.0743 81.1394 32.3452 81.1115 32.5697 81.03C37.8813 79.1021 43.419 77.1742 48.7207 75.2463C49.9513 74.7541 50.4435 75.0002 50.6897 75.7386C50.9358 76.4769 50.6897 77.2153 49.4591 77.7075C43.8882 79.6452 38.5556 81.8213 32.9923 83.7666C32.8141 83.8289 32.6918 83.8606 32.503 83.8606Z",
    fill: "url(#paint2_linear_2305_20661)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4883 93.5597C44.8093 92.3484 47.0433 95.1078 43.8578 96.6403C43.2281 96.9433 42.5692 97.2043 41.8927 97.4193C38.2633 98.5726 37.9106 94.8646 41.4883 93.5597Z",
    fill: "url(#paint3_linear_2305_20661)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0745 4.61182C42.0745 5.5963 42.0745 6.58078 42.0745 7.56527C42.0745 8.30363 41.5822 8.79587 40.8439 8.79587C40.1055 8.79587 39.6133 8.30363 39.6133 7.56527C39.6133 5.5963 39.6133 3.62733 39.6133 1.41224C39.6133 0.673882 40.1055 0.181641 40.8439 0.181641C41.5822 0.181641 42.0745 0.673882 42.0745 1.41224C42.0745 2.39673 42.0745 3.62733 42.0745 4.61182Z",
    fill: "url(#paint4_linear_2305_20661)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91061 39.0723C5.8951 39.0723 6.87961 39.0723 7.86409 39.0723C8.84858 39.0723 9.34083 39.5645 9.34083 40.3029C9.34083 41.0412 8.84858 41.5335 7.86409 41.5335C5.89513 41.5335 3.92618 41.5335 1.95721 41.5335C0.972725 41.5335 0.480469 41.0412 0.480469 40.3029C0.480469 39.5645 0.972725 39.0723 1.95721 39.0723C2.94169 39.0723 3.92613 39.0723 4.91061 39.0723Z",
    fill: "url(#paint5_linear_2305_20661)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7778 41.7757C75.7934 41.7757 74.8088 41.7757 73.8244 41.7757C73.086 41.7757 72.5938 41.2834 72.5938 40.5451C72.5938 39.8067 73.086 39.3145 73.8244 39.3145C75.7933 39.3145 78.0084 39.3145 79.9774 39.3145C80.7157 39.3145 81.208 39.8067 81.208 40.5451C81.208 41.2834 80.7157 41.7757 79.9774 41.7757C78.7468 41.7757 77.7623 41.7757 76.7778 41.7757Z",
    fill: "url(#paint6_linear_2305_20661)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8166 11.7711C12.2864 11.2008 13.2477 11.2257 13.7701 11.7481C15.2469 13.2249 16.4775 14.4555 17.9542 15.9322C18.6926 16.6705 18.6926 17.1628 17.9542 17.9011C17.8152 18.0401 17.6566 18.1399 17.4839 18.2004C16.4895 18.5487 15.612 17.5236 14.8468 16.7992C13.7632 15.7733 12.7144 14.813 11.8012 13.7171C11.5788 13.4947 11.3564 12.8703 11.4972 12.3888C11.527 12.2869 11.5693 12.1884 11.6138 12.092C11.6697 11.9712 11.7392 11.8652 11.8166 11.7711Z",
    fill: "url(#paint7_linear_2305_20661)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3782 62.9488C63.776 62.5796 64.5356 62.5651 64.941 62.9258C65.0383 63.0124 65.1249 63.099 65.2115 63.1856C66.6882 64.4162 67.9189 65.893 69.3956 67.1236C70.134 67.8619 70.134 68.6003 69.6417 69.0925C69.1495 69.5848 68.4111 69.5848 67.6727 68.8464C66.196 67.3697 64.9654 66.1391 63.4887 64.6624C63.3024 64.4761 63.1161 64.0077 63.1433 63.5776C63.1602 63.3105 63.182 63.131 63.3782 62.9488Z",
    fill: "url(#paint8_linear_2305_20661)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2949 11.5927C69.7389 12.1122 69.8765 12.9921 69.3933 13.4752C67.9166 14.952 66.6859 16.1826 65.2092 17.6593C64.717 18.1515 63.9786 18.3977 63.2403 17.6593C63.1013 17.5203 63.0015 17.3617 62.941 17.189C62.5927 16.1946 63.6178 15.3171 64.3422 14.552C65.3681 13.4682 66.3284 12.4195 67.4243 11.5063C67.6704 11.2601 68.4088 11.014 68.901 11.2601C69.0504 11.3348 69.1771 11.4549 69.2949 11.5927Z",
    fill: "url(#paint9_linear_2305_20661)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5564 69.2056C13.1934 69.6889 12.4808 69.4164 12.0666 68.9761C12.0429 68.9509 12.0197 68.9249 11.9971 68.8981C11.8455 68.7176 11.708 68.5346 11.6935 68.2994C11.6576 67.7189 12.0328 67.1417 12.4364 66.7231C13.7058 65.4062 15.0011 63.9605 16.4771 62.6954C16.9693 62.2031 17.7076 62.2031 18.1999 62.6954C18.6921 63.1876 18.6921 63.926 18.1999 64.4182C16.8103 65.8077 15.4208 67.1973 14.0313 68.5868C13.858 68.7601 13.7035 69.0097 13.5564 69.2056Z",
    fill: "url(#paint10_linear_2305_20661)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2305_20661",
    x1: 21.6868,
    y1: 98.5922,
    x2: 82.6306,
    y2: 82.9706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2305_20661",
    x1: 33.2566,
    y1: 95.2056,
    x2: 50.6721,
    y2: 83.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2305_20661",
    x1: 33.2593,
    y1: 87.0806,
    x2: 50.6816,
    y2: 74.8566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2305_20661",
    x1: 34.1988,
    y1: 100.804,
    x2: 48.9015,
    y2: 89.9938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2305_20661",
    x1: 39.8945,
    y1: 11.9229,
    x2: 43.1043,
    y2: 11.6343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2305_20661",
    x1: 1.49273,
    y1: 42.4269,
    x2: 6.59371,
    y2: 36.6476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2305_20661",
    x1: 73.5779,
    y1: 42.6691,
    x2: 78.6947,
    y2: 37.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2305_20661",
    x1: 12.2591,
    y1: 20.906,
    x2: 20.7411,
    y2: 18.3122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2305_20661",
    x1: 63.9225,
    y1: 71.9724,
    x2: 72.14,
    y2: 69.4396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2305_20661",
    x1: 63.7006,
    y1: 20.6544,
    x2: 72.3191,
    y2: 17.8278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2305_20661",
    x1: 12.4772,
    y1: 72.2224,
    x2: 20.7813,
    y2: 69.7468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.4d9dea01df7b157096f8575db9563529.svg";
export { ForwardRef as ReactComponent };